import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersist from 'vuex-persist'
import moduleOffers from '@/stores/offers'
import moduleAuth from '@/stores/auth'
import moduleStores from '@/stores/stores'
import moduleClusters from '@/stores/clusters'
// import { connect } from 'tls';
// import { resolve } from 'path';
// import _ from 'lodash'

Vue.use(Vuex)

const vuexLocalStorage = new VuexPersist({
  key: 'vuex',
  storage: window.localStorage,
  reducer: state => ({
    auth: {
      loggedIn: state.auth.loggedIn
    }
  })
})

export default new Vuex.Store({
  modules: {
    offers: moduleOffers.offers,
    auth: moduleAuth.auth,
    stores: moduleStores.stores,
    clusters: moduleClusters.clusters
  },
  state: {},
  getters: {},
  mutations: {},
  actions: {},
  plugins: [vuexLocalStorage.plugin]
})
